import store from '@/store';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';


// import CategoryView from '@/views/CategoryView.vue';
import MainView from '@/views/Main.vue';

import Services from '@/views/Services/Services.vue';
import ServicesForm from '@/views/Services/ServicePaymentFormView.vue';
import ServicePaymentStatus from '@/views/Services/ServicePaymentStatus.vue';
import ServiceCategory from '@/views/Services/ServiceCategoryView.vue';
import ServiceList from '@/views/Services/ServiceListView.vue';

import SimRemittances from '@/views/Remittances/SimRemittances.vue';
import CardRemittances from '@/views/Remittances/CardRemittances.vue';

import PaymentStatus from '@/views/PaymentStatus.vue';
import ConfirmOTP from '@/views/ConfirmOTP.vue';
import Iframe from '@/views/iframe.vue';
import { sendPostMessage } from '@/util/helper';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'main',
    component: MainView
  },
  {
    path: '/sim-remittances',
    name: 'sim-remittances',
    component: SimRemittances
  },
  {
    path: '/card-remittances',
    name: 'card-remittances',
    component: CardRemittances
  },
  {
    path: '/service/:id',
    name: 'service',
    component: ServicesForm
  },
  {
    path: '/status',
    name: 'status',
    component: PaymentStatus
  },
  {
    path: '/confirm',
    name: 'confirm',
    component: ConfirmOTP
  },
  {
    path: '/service-status',
    name: 'service-status',
    component: ServicePaymentStatus
  },
  {
    path: '/iframe',
    name: 'iframe',
    component: Iframe
  },
  {
    path: '/service-category',
    name: 'service-category',
    component: ServiceCategory
  },
  {
    path: '/service-list/:id',
    name: 'service-list',
    component: ServiceList
  },
  { 
    path: '/:pathMatch(.*)*', 
    name: 'NotFound',
    component: MainView 
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior () {
    return { top: 0 };
  }
});

router.beforeEach((to, from) => {
  sendPostMessage('scroll_top', 'success', '');
  sendPostMessage('changed_frame_url', 'success', to.path);
  
  store.commit('setPrevRoute', from.path);
});

export default router;
